import { UtilityButton } from '@quickbit/qb-design-system';
import { useAsyncFn } from 'react-use';
import { retriggerOnboarding } from 'tabs/NewSkinning/SkinningUsers/api';

interface Props {
  userReference: string;
}

export const RetriggerOnboarding = ({ userReference }: Props) => {
  const [{ loading, value, error }, retrigger] = useAsyncFn(
    async () => retriggerOnboarding(userReference),
    [userReference]
  );

  return (
    <UtilityButton
      text="Re-trigger onboarding"
      onClick={retrigger}
      loading={loading}
      disabled={loading || !!value || !!error}
    />
  );
};
